import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo-transparent.png";
import usePageMeta from "../hooks/usePageMeta";

function LegalMentionsPage() {
  usePageMeta({
    title: "Mentions légales",
    description:
      "Consultez les mentions légales du site portfolio de Sofiane Amroune.",
  });

  return (
    <div className="page-shell space-y-8 lg:space-y-10">
      <section className="hero-panel">
        <div className="grid items-center gap-8 lg:grid-cols-[1.2fr,0.8fr]">
          <div>
            <span className="eyebrow">Informations légales</span>
            <h1>Mentions légales</h1>
            <p className="mt-5 max-w-2xl text-lg leading-8 text-muted">
              Cette page présente les informations relatives à l’éditeur du site,
              à l’hébergement et aux droits de propriété intellectuelle.
            </p>
          </div>
          <div className="flex justify-center lg:justify-end">
            <div className="flex h-40 w-40 items-center justify-center rounded-full border border-brand/20 bg-white/85 shadow-panel sm:h-48 sm:w-48">
              <img
                src={logo}
                alt="Logo Sofiane Amroune"
                className="h-28 w-28 object-contain sm:h-32 sm:w-32"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="legal-section">
        <h2 className="text-3xl">Éditeur du site</h2>
        <p>
          Le site <strong>samroune.fr</strong> est édité par <strong>Sofiane Amroune</strong>.
        </p>
        <ul className="space-y-3">
          <li><strong>Nom :</strong> Sofiane Amroune</li>
          <li>
            <strong>Contact :</strong> via la page{" "}
            <Link to="/contact" className="content-link">
              Contact
            </Link>
            .
          </li>
        </ul>
      </section>

      <section className="legal-section">
        <h2 className="text-3xl">Hébergement du site</h2>
        <p>Le site est hébergé par OVH.</p>
        <ul className="space-y-3">
          <li><strong>Hébergeur :</strong> OVH</li>
          <li><strong>Adresse :</strong> 2 Rue Kellermann, 59100 Roubaix, France</li>
          <li><strong>Téléphone :</strong> 1007</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2 className="text-3xl">Propriété intellectuelle</h2>
        <p>
          Sauf mention contraire, les contenus présents sur ce site (textes, images,
          illustrations, logos) sont la propriété de <strong>Sofiane Amroune</strong>.
          Toute reproduction, diffusion, modification ou utilisation sans autorisation
          préalable est interdite.
        </p>
      </section>

      <section className="legal-section">
        <h2 className="text-3xl">Crédits visuels</h2>
        <p>
          Les illustrations éventuellement utilisées sur le site proviennent de la
          bibliothèque <strong>unDraw</strong> et sont utilisées conformément à sa licence.
        </p>
        <p>
          <a
            href="https://undraw.co/license"
            target="_blank"
            rel="noopener noreferrer"
            className="content-link"
          >
            Consulter la licence unDraw
          </a>
        </p>
      </section>
    </div>
  );
}

export default LegalMentionsPage;
